import { saveState } from '@/store/persistence/stateManager.js'

const skipMutations = ['syncState', 'setFetched', 'setLoading']
const skipStates = ['fetched', 'loading', 'promise', 'promises']
const skipModules = []

const filteredState = (state) =>
  Object.keys(state)
    .filter((key) => !skipStates.includes(key))
    .reduce((obj, key) => {
      obj[key] = state[key]
      return obj
    }, {})

// function that creates a store plugin
export function createPolyglotPlugin() {
  return (store) => {
    // called when the store is initialized
    store.subscribe((mutation, state) => {
      // called after every mutation
      // (the mutation comes in the format of `{ type, payload }`)
      const parts = mutation.type.split('/')
      const [moduleName, mutationName] = parts.length > 1 ? parts : ['root', parts[0]]

      // avoid persisting state:
      //   1)redundantly during session initialization ("syncState")
      //   2)for "loading" states (e.g. "setLoading")
      if (skipMutations.includes(mutationName)) return
      if (skipModules.includes(moduleName)) return
      // console.debug(`[store]: ${moduleName}:${mutationName} state=`, state[moduleName])

      // console.debug(`[store]: ${module}:${action} = ${mutation.payload}`)
      saveState(moduleName, filteredState(state[moduleName]))
    })
  }
}
